$(function () {

    // Due to our default configuration of jquery.validation in jquery.validation.js, SelectPickers
    // are automatically ignored from client-side valiations using a css selector :hidden.  This
    // works because the SelectPicker hides the actual html element and generates its own elements
    // the user interacts with.
    //
    // As a result, we have to _Include_ the SelectPicker when it should be validated.  This is
    // determined by the visibility of the button UI element.
    $.validator.include(function (index, element) {
        var isSelectPicker = $(element).hasClass("selectpicker");

        // Only worry about select pickers in here
        if (isSelectPicker) {
            var nextElement = $(element).next();

            // check that the user-facing button meets the visibility requirement
            if (nextElement.is("button[role=combobox]") && nextElement.is(':visible')) {

                // the button is visible, so we should validate
                return true;
            }
        }     
    });
});